// @ts-nocheck


import { downloadRequestWithToken, fetchRequest } from './index';






import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as convertDataFromServerMdm } from './mdm';

export const convertDataToServer = (
materialCalculation) => (
{
  ...materialCalculation,
  sum: convertFromRubToKop(materialCalculation.sum),
  months: materialCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
materialCalculation) => (
{
  ...materialCalculation,
  sum: convertFromKopToRub(materialCalculation.sum),
  mtr: convertDataFromServerMdm(materialCalculation.mtr),
  months: materialCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
materialCalculationMonth) => (
{
  ...materialCalculationMonth,
  cost: convertFromRubToKop(materialCalculationMonth.cost)
});

export const convertDataFromServerMonth = (
materialCalculationMonth) => (
{
  ...materialCalculationMonth,
  cost: convertFromKopToRub(materialCalculationMonth.cost)
});

const basedUrl = 'materialCalculation';
const materialCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в инструментах, материалах (РЭН)',
  convertDataToServer,
  convertDataFromServer
);

export const addOrUpdate = async (
data) =>
{
  const updated = await fetchRequest.post(`/${basedUrl}/addOrUpdate`, data);
  if (updated) return updated;
  throw new Error(`Не удалось отредактировать`);
};

export const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...materialCalculation,
  changeStatus,
  addOrUpdate,
  print
};
